import Flex from "@/shared/components/common/Flex";
import { cn } from "@/shared/libs/commonUtils";
import type { ReactNode } from "react";
interface FlightCardPanelProps {
  isOpen: boolean;
  children: ReactNode;
}
export default function FlightCardPanel({
  isOpen,
  children,
}: FlightCardPanelProps) {
  return (
    <Flex
      className={cn(
        "w-full transition-[max-height] duration-200 ease-linear overflow-hidden",
        isOpen ? "max-h-60 border-t-[1px] border-grayColor" : "max-h-0",
      )}
    >
      {children}
    </Flex>
  );
}
